import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { memo } from 'react';
export const ComplianceStats = /*#__PURE__*/ memo(function ComplianceStats({ stats, currentVersionCount, totalAcrossVersions }) {
    // Only adopt the "Current Requirements" framing when there's actual
    // amendment history to disclose. When every logical group has exactly
    // one row (legacy data, or single-doc projects), the original "Total
    // Requirements" label is the honest one.
    const showAmendmentBreakdown = currentVersionCount !== undefined && totalAcrossVersions !== undefined && totalAcrossVersions > currentVersionCount;
    const headlineCount = showAmendmentBreakdown ? currentVersionCount : stats.total;
    const headlineLabel = showAmendmentBreakdown ? 'Current Requirements' : 'Total Requirements';
    return /*#__PURE__*/ _jsx("div", {
        className: "bg-white rounded-lg border border-gray-200 p-4",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-2xl font-bold text-gray-900",
                            children: headlineCount
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-sm text-gray-600 mt-1",
                            children: headlineLabel
                        }),
                        showAmendmentBreakdown && /*#__PURE__*/ _jsxs("div", {
                            className: "mt-0.5 text-[11px] text-gray-400",
                            children: [
                                "of ",
                                totalAcrossVersions.toLocaleString(),
                                " across all amendments"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-2xl font-bold text-green-600",
                            children: stats.addressed
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-sm text-gray-600 mt-1",
                            children: "Addressed"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-2xl font-bold text-yellow-600",
                            children: stats.partial
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-sm text-gray-600 mt-1",
                            children: "Partial"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-2xl font-bold text-gray-500",
                            children: stats.notAddressed
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-sm text-gray-600 mt-1",
                            children: "Not Started"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "text-2xl font-bold text-blue-600",
                            "data-testid": Testids.compliance.scoreValue,
                            children: [
                                stats.complianceScore.toFixed(1),
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-sm text-gray-600 mt-1",
                            children: "Compliance Score"
                        })
                    ]
                })
            ]
        })
    });
});
